import { PATHS } from 'constants/routerPaths';

const PUBLIC_PATHS = [PATHS.LOGIN, PATHS.TEMPORARY_PASSWORD, PATHS.DOWNLOAD_APP_INSTRUCTION];

const isPrivateRoute = (pathname: string) => !PUBLIC_PATHS.includes(pathname);

export default isPrivateRoute;
